import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { ConstructionTab } from '../../../reducers/construction'
import { Box } from '@mui/material'
import HideShowOptions from './HideShowOptions'
import EditingTools from './EditingTools'

const BottomPanel = () => {
  const isEditorTab = useSelector(
    (state: RootState) =>
      state.construction.selectedConstructionTab === ConstructionTab.Editor,
  )
  const isValidationTab = useSelector(
    (state: RootState) =>
      state.construction.selectedConstructionTab === ConstructionTab.Validation,
  )

  if (!isEditorTab && !isValidationTab) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        margin: '12px',
        gap: '32px',
      }}
    >
      <EditingTools />

      <HideShowOptions />
    </Box>
  )
}

export default BottomPanel
